import type { ReactNode } from 'react';

interface PortalSectionProps {
  title: string;
  /** Right-aligned action (e.g. "Show all") */
  action?: ReactNode;
  /** Shown when there are no children rows */
  empty?: string;
  children?: ReactNode;
}

export function PortalSection({ title, action, empty, children }: PortalSectionProps) {
  const hasChildren = Array.isArray(children) ? children.some(Boolean) : !!children;
  return (
    <section className="space-y-2">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-semibold">{title}</h2>
        {action}
      </div>
      {hasChildren ? (
        <div className="space-y-2">{children}</div>
      ) : (
        empty && <p className="rounded-lg border border-dashed px-4 py-4 text-sm text-muted-foreground">{empty}</p>
      )}
    </section>
  );
}
